import { Component, Input, OnInit } from '@angular/core';
import { IconConfig, StarIconConfig } from './star-rating.constants';
import { checkInputsForText } from '../../design-system.helper';

@Component({
  selector: 'star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss'],
})
export class StarRatingComponent implements OnInit {
  @Input() rating: number;
  // Allow custom names for star icons
  // If `starFilledIcon` is not specified then we will use `star_active` and `star_filled` overlayed
  // in order to display properly, regardless of which of the two system font files is used
  // TODO: Resolve divergence of system icon files:
  // https://d32ul9oyxvd2n5.cloudfront.net/icons/system-icons.woff
  // https://d1f0xtw5zu5qh9.cloudfront.net/files/8822f467-1db2-4ca0-9f5b-4ae565455185.woff
  @Input() starIcon = 'star';
  @Input() starFilledIcon: string;
  @Input() config: IconConfig;
  @Input() starConfig: StarIconConfig;
  @Input() direction: 'row' | 'column' = 'row';
  @Input() starColorChange: boolean;

  numberOfStars: number;
  stars: any[] = [];
  starWidth: number;
  starWidthRounded: number;
  displayRating: number;
  iconConfig: any;

  ngOnInit() {
    const [config, starConfig] = checkInputsForText([
      this.config,
      this.starConfig,
    ]);
    const ten = 10;
    const twenty = 20;
    const hundred = 100;
    const numberOfStars = 5;

    this.config = config;
    this.starConfig = starConfig;
    this.numberOfStars = numberOfStars;

    this.stars = Array(this.numberOfStars).fill(0);
    this.displayRating = Math.round(this.rating * ten) / ten;
    this.starWidth = (this.displayRating / this.numberOfStars) * hundred;
    this.starWidthRounded = Math.round(this.starWidth * ten) / ten;

    // Any rating of x.1 to x.9 should display a half star
    if (this.starWidthRounded % twenty < ten) {
      this.starWidthRounded = Math.ceil(this.starWidthRounded / ten) * ten;
    } else if (this.starWidthRounded % twenty > ten) {
      this.starWidthRounded = Math.floor(this.starWidthRounded / ten) * ten;
    }

    if (this.starColorChange) {
      this.iconConfig = new StarIconConfig(this.starConfig);
    } else {
      this.iconConfig = new IconConfig(this.config);
    }
  }
}
